import { useCallback, useEffect, useMemo } from 'react'
// import { useRouter } from 'next/navigation'
import { format, addDays } from 'date-fns'
// import useGetActivePlanDetails from '@hooks/usetGetActivePlanDetails'
// import useGetLoggedInUser from '@hooks/useGetLoggedInUser'
import {
  confirmOrderRequest,
  createLabTestOrderRequest,
  createPayload,
  getAppointmentSlotsRequest,
} from '../../../redux/slices'
import { useDispatch, useSelector } from 'react-redux'
import useRazorpay from '../../../hooks/useRazorpay'
import {
  DEFAULT_REPORT_EMAIL,
  DEFAULT_VENDOR_FLAG,
  DEV_FLAGS,
  GOODFLIP_DIAGNOSTIC_REPORT_TYPE,
} from '../../../constants/common'
import useGetLoggedInUser from '../../../hooks/useGetLoggedInUser'

const allowedNumberOfdays = 6

const useGetDiagnosticSlots = () => {
  // const router = useRouter()
  const {
    source,
    userDetails,
    condition_name,
    therapy_area,
    mappedConditionName,
  } = useGetLoggedInUser()

  const {
    initiatePayment,
    error: paymentErr,
    loading: paymentLoading,
  } = useRazorpay()
  const {
    appointmentSlots: { loading, slotsResponse, error },
    createLabTestOrderState: {
      loading: creatingOrder,
      success: orderCreated,
      error: createOrderError,
      data: createOrderResponse,
    },
    confirmOrderState,
  } = useSelector((state) => state.diagnostics)

  const { formFields: storedFormFields } = useSelector(
    (state) => state.formPayload,
  )
  const dispatch = useDispatch()
  // const [paymentStatus, setPaymentStatus] = useState<PaymentStatus | null>(
  //   null
  // );
  // const [isLoading, setIsLoading] = useState<boolean>(false);

  const reference_data = {
    source,
    conditionName: mappedConditionName,
    type: GOODFLIP_DIAGNOSTIC_REPORT_TYPE,
  }

  const defaultFormValues = useMemo(() => {
    const date = format(addDays(new Date(), 1), 'yyyy-MM-dd')
    return {
      disease_name: mappedConditionName,
      address_id:
        storedFormFields?.addressResponse?.patient_address_rel_id || '',
      appointment_date: date,
      slot_time: '',
      collection_slot_id: '',
      vendor_flag: DEFAULT_VENDOR_FLAG,
      email: DEFAULT_REPORT_EMAIL,
      force_add: 'Y',
      empty_cart: true,
      ...(DEV_FLAGS.includes(process.env.REACT_APP_ENV) && {
        dev: true,
      }),
      reference_data: JSON.stringify(reference_data),
    }
  }, [condition_name, userDetails, storedFormFields])

  const fetchSlots = useCallback(
    (date) => {
      const { pincode, latitude, longitude } = storedFormFields?.addressPayload
      dispatch(
        getAppointmentSlotsRequest({
          Pincode: pincode || null,
          Date: date,
          vendor_flag: DEFAULT_VENDOR_FLAG,
          latitude: latitude || '',
          longitude: longitude || '',
        }),
      )
    },
    [dispatch, storedFormFields],
  )

  const createOrder = async (payload) => {
    dispatch(createLabTestOrderRequest(payload))
    dispatch(createPayload({ createOrderPayload: { ...payload } }))
  }

  const handlePaymentWindow = async (orderId) => {
    try {
      const response = await initiatePayment({
        orderId,
        description: 'Lab test description',
      })
      if (response) {
        confirmOrder(response)
      }
    } catch (err) {
      console.log('Payment Failed:', err)
    }
  }

  useEffect(() => {
    if (orderCreated && !creatingOrder && !createOrderError) {
      handlePaymentWindow(createOrderResponse?.razorpay_order_id || '')
    }
  }, [orderCreated, creatingOrder, createOrderResponse, createOrderError])

  const confirmOrder = (res) => {
    dispatch(
      confirmOrderRequest({
        order_master_id: createOrderResponse?.order_master_id,
        transaction_id: res.razorpay_payment_id,
      }),
    )
  }

  // useEffect(() => {
  //   // TODO: Need to verify the payment status
  //   const { loading, error, success } = confirmOrderState
  //   if (!loading) {
  //     if (success || error) {
  //       router.push(
  //         `${baseUrl}/payment-status?status=${success ? 'success' : 'failed'}&page=diagnostics`,
  //       )
  //     }
  //   }
  // }, [confirmOrderState])

  const dates = useMemo(() => {
    return Array.from({ length: allowedNumberOfdays }, (_, i) => {
      const date = addDays(new Date(), i)
      return {
        day: format(date, 'EEE'),
        date: format(date, 'd'),
        fullDate: format(date, 'yyyy-MM-dd'),
      }
    })
  }, [])

  return {
    dates,
    loading,
    error,
    slotsResponse,
    fetchSlots,
    createOrder,
    defaultFormValues,
    paymentErr,
    paymentLoading,
    creatingOrder,
    orderCreated,
    createOrderResponse,
    createOrderError,
    storedFormFields,
    confirmOrderState,
  }
}
export default useGetDiagnosticSlots
